import React, { useEffect, useState } from "react";

import styles from "./ProgressiveBarStyles.module.scss";

const ProgressiveBar = () => {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    updateDimensions();
    window.addEventListener("scroll", updateDimensions);
    return () => {
      window.removeEventListener("scroll", updateDimensions);
    };
  }, []);

  const updateDimensions = () => {
    const totalHeight = document.body.offsetHeight - window.innerHeight;
    const scrolledPercentage = (window.scrollY / totalHeight) * 100;
    setHeight(scrolledPercentage);
  };
  return (
    <div className={`${styles.progressbar}`}>
      <div style={{ width: `${height}%` }}></div>
    </div>
  );
};

export default ProgressiveBar;
